import { zoneFromBrandAndCountry } from '@seek/audience-zones';
import type { ConfigStateContext } from '../../client/shared/hooks/useConfig';

type ZoneCountry = 'AU' | 'NZ' | 'HK' | 'ID' | 'MY' | 'PH' | 'SG' | 'TH';

const HYPGRAPH_MEDIA_REGX = /^https:\/\/media.graphassets.com\//;

const WIDTH = 1200;
const HEIGHT = 630;

export const extractImageUrl = (context: any) => {
  const data = context?.loaderData;
  if (!data) {
    return null;
  }
  const value: any = Object.values(data)[1];
  if (!value) {
    return null;
  }
  const seoImage = value?.seo?.image?.url;
  const featureImage = value?.featureImage && value?.featureImage[0]?.url;
  return seoImage || featureImage;
};

export const resizeImage = (
  imageUrl: string,
  width = WIDTH,
  height = HEIGHT,
) => {
  if (!HYPGRAPH_MEDIA_REGX.test(imageUrl)) {
    return imageUrl;
  }

  const [protocol, , domain, ...rest] = imageUrl.split('/');
  return `${protocol}//${domain}/resize=fit:crop,width:${width},height:${height}/${
    rest[rest.length - 1]
  }`;
};

export const getZone = (config: ConfigStateContext) => {
  const { country, brand } = config;
  const zone =
    zoneFromBrandAndCountry(brand, country.toUpperCase() as ZoneCountry) ||
    'anz-1';
  return zone;
};
